<ion-note class="gray-text user-profile">{{isAdmin ? UserProfile.Administrator : UserProfile.Collaborator}}</ion-note>
